import script from "./TypeManuallyVideoCaptionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypeManuallyVideoCaptionModal.vue?vue&type=script&lang=ts&setup=true"

import "./TypeManuallyVideoCaptionModal.vue?vue&type=style&index=0&id=196fec69&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196fec69"]])

export default __exports__